export const MAIN = '/'
export const SIGN_IN = '/sign-in'
export const SIGN_UP = '/sign-up'
export const NOT_FOUND = '*'
export const ACCOUNTSETTINGS = '/account-settings'
export const PROJECT = '/project/'
